/** @format */

import React, { useRef } from "react";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import img from "../../assets/raw_img/DigitalSolution.jpg";

import sacredgeo_1 from "../../assets/scaredGeo/artBoard1.png";

const DigitalSolution = ({ id, removeList }) => {
  const [ref, inView] = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });
  const [ref_3, inView3] = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });
  const variants_img_3 = {
    visible: { scale: 1 },
    hidden: { scale: 0.1 },
  };
  const variants_title = {
    visible: { opacity: 1, x: 0 },
    hidden: {
      opacity: 0,
      x: -20,
    },
  };

  const variants_description = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: -30,
    },
  };

  const variants_img = {
    visible: { scale: 1 },
    hidden: {
      scale: 0.95,
    },
  };

  return (
    <div
      id={id}
      className="flex flex-col-reverse md:block lg:grid grid-cols-2 items-center mx-auto w-[80%] lg:w-[70%] gap-10 pv:max-ph:grid-cols-1 pv:max-ph:w-[90%] ph:max-sm:grid-cols-1 ph:max-sm:w-[70%] sm:max-md:grid-cols-2 sm:max-md:w-[95%] md:max-lg:grid-cols-2 md:max-lg:w-[80%] lg:max-xl:grid-cols-2 lg:max-xl:w-[80%] xl:max-dv:grid-cols-2 xl:max-dv:w-[80%] pb-20 !h-fit"
    >
      <div className="overflow-hidden rounded-md h-fit">
        <div className="hover:scale-105 duration-300  h-[600px]  ease-in-out w-full rounded-md pv:max-md:h-[300px] md:max-lg:h-[400px] cursor-pointer">
          <motion.img
            src={img}
            className="object-cover rounded-md w-full h-[600px]  pv:max-md:h-[300px] md:max-lg:h-[400px] "
            animate={inView ? "visible" : "hidden"}
            variants={variants_img}
            transition={{ duration: 0.75, ease: "easeOut" }}
            ref={ref}
          ></motion.img>
        </div>
      </div>

      <div className="flex-col justify-center flex  pv:max-md:col-span-1 w-full relative h-fit">
        <motion.p
          className="text-[28px] lg:text-[36px] font-semibold  text-black cursor-pointer h-auto"
          animate={inView ? "visible" : "hidden"}
          variants={variants_title}
          transition={{ duration: 2, ease: "easeOut" }}
          ref={ref}
        >
          DIGITAL SOLUTION CONSULTANCY & DEVELOPMENT
        </motion.p>
        <div className="relative h-auto">
          <motion.p
            className="2xl:text-[18px] leading-10 font-sans pt-4 text-[#333333] text-start h-auto"
            animate={inView ? "visible" : "hidden"}
            variants={variants_description}
            transition={{ duration: 2, ease: "easeOut" }}
            ref={ref}
          >
            We understand the importance technology play in defining the future
            profitability and sustainability of businesses. Leveraging from our
            global partner network, we constantly engage with global
            institutions as well as technology vendors and owners, enabling us
            to keep up with the latest market development and trend. On the
            other hand, our deep local knowledge and relation withs corporations
            in Vietnam enable us to understand the priorities and visions of our
            clients from the technology view. This vantage position enables us
            to deliver projects quickly, efficiently, minimizing cost and risk
            for all parties.
          </motion.p>
          {/* Geometry_3 */}
          <div className="absolute w-[60%] h-[60%] ph:max-sm:h-[350px] ph:max-sm:w-[350px] top-[10%] left-[10%]">
            <motion.div
              ref={ref_3}
              animate={inView3 ? "visible" : "hidden"}
              variants={variants_img_3}
              transition={{ duration: 1.5, ease: "easeOut" }}
              className=" w-full h-full z-[-100]"
            >
              <img className="opacity-50" src={sacredgeo_1}></img>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalSolution;
